var map = {
	"./dashboard/index.js": "./assets/js/components/com_imc/dashboard/index.js",
	"./memorandum/inbox/index.js": "./assets/js/components/com_imc/memorandum/inbox/index.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/js/components/com_imc sync recursive ^\\.\\/.*\\/index\\.js$";